import React, { useState } from "react";
import CustomerAuthService from "../services/CustomerAuthServices";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState({ type: "", text: "" });

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg({ type: "", text: "" });

    const em = email.trim();

    if (!em) {
      setMsg({ type: "danger", text: "Email is required." });
      return;
    }

    try {
      setLoading(true);
      const res = await CustomerAuthService.forgotPassword(em);

      setMsg({
        type: "success",
        text: res?.message || "Reset link sent to your email.",
      });
    } catch (err) {
      const apiMsg = err?.response?.data?.message;

      setMsg({
        type: "danger",
        text: apiMsg || "Failed to send reset link.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <BreadcrumbTwo title="Forgot Password" />

      <section className="py-80">
        <div className="container container-lg">
          <div className="row justify-content-center">
            <div className="col-xl-6">
              {msg?.text && (
                <div className={`alert alert-${msg.type || "info"} mb-24`}>
                  {msg.text}
                </div>
              )}

              <div className="border border-gray-100 rounded-16 px-24 py-40">
                <h5 className="mb-16">Reset your password</h5>

                <p className="text-neutral-600 mb-24">
                  Enter your email and we will send you a password reset link.
                </p>

                <form onSubmit={onSubmit}>
                  <div className="mb-24">
                    <label className="text-neutral-900 text-lg mb-8 fw-medium">
                      Email <span className="text-danger">*</span>
                    </label>

                    <input
                      type="email"
                      className="common-input"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <button
                    disabled={loading}
                    className="btn btn-main py-18 px-40"
                    type="submit"
                  >
                    {loading ? "Sending..." : "Send reset link"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}